// Typelizer digest c6f7a1544f1f890e33de3915cfdfb9f7
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from './runtime'
import { buildUrl } from './runtime'

export default {
  /** POST /alerts/test_email */
  testEmail: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/alerts/test_email', {}, options),
    method: 'post',
  }),

  /** GET /alerts */
  show: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/alerts', {}, options),
    method: 'get',
  }),

  /** PATCH /alerts */
  update: (options?: RouteOptions): RouteDefinition<'patch'> => ({
    url: buildUrl('/alerts', {}, options),
    method: 'patch',
  }),
}
